import React from 'react';

import { Switch, SwitchProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { useStyles } from './AppSwitch.styles';

interface AppSwitchProps extends SwitchProps {
  value: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export default function AppSwitch(props: AppSwitchProps) {
  const { value, onChange = () => {}, className, ...otherProps } = props;
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <Switch
      className={clsx(classes.switchWrapper, className)}
      classes={{
        root: classes.switchRoot,
        track: classes.switchTrack,
        switchBase: classes.switchBase,
        checked: classes.switchChecked,
      }}
      checked={value}
      onChange={onChange}
      {...otherProps}
    />
  );
}
